import { connect } from 'react-redux'
import { pageToggleOverlay, textEditorSetSelectionFunction } from 'redux/actions'
import TextEditor from 'components/shared/texteditor'

const mapStateToProps = (state) => ({
  controller: state.layout.controller
})

const mapDispatchToProps = dispatch => ({
  pageToggleOverlay: (component) => dispatch(pageToggleOverlay(component)),
  setSelectionFunction: setSelection => dispatch(textEditorSetSelectionFunction(setSelection))
})

export default connect(mapStateToProps, mapDispatchToProps)(TextEditor)
